<template>
  <v-container style="max-width: 800px">
    <v-card>
      <v-card-title>
        <h4 class="text-center w-full">POLÍTICA DE PRIVACIDADE</h4>
      </v-card-title>
      <v-card-text class="px-4">
        <div class="gap-3 align-center pb-9">
          <span
            class="text-overline lh-1 font-weight-bold text-10 text--lighten-2 mb-0"
          >
            {{ legalInfo.legalName }}
          </span>
          <h5 class="font-weight-bold text--lighten-2 mb-0">
            {{ legalInfo.fantasyName }}
          </h5>
          <span class="text--lighten-2 text-15">
            {{ legalInfo.document }}
          </span>
        </div>

        <h5>1. Introdução e Aceite</h5>
        <p>
          Esta Política de Privacidade regulamenta a forma como a nossa
          plataforma de ingressos coleta, armazena, trata e protege os dados
          pessoais de seus usuários. O documento foi elaborado em estrita
          conformidade com a Lei Geral de Proteção de Dados Pessoais (LGPD –
          Lei nº 13.709/2018), o Marco Civil da Internet (Lei nº 12.965/2014) e
          as diretrizes e termos de uso da Meta para a utilização da API oficial
          do WhatsApp.
        </p>
        <p>
          Ao utilizar nossa plataforma e fornecer seus dados, o usuário
          manifesta ciência e concordância com os termos aqui estipulados.
        </p>

        <h5>2. Dados Pessoais Coletados</h5>
        <p>
          Para garantir a segurança das transações, prevenir fraudes e permitir
          a emissão nominal dos ingressos, coletamos os seguintes dados no
          momento do cadastro ou compra:
        </p>
        <ul>
          <li>
            <strong>Dados Cadastrais e de Contato:</strong> Nome completo,
            número de telefone celular (WhatsApp), endereço de e-mail e
            Documento de Identificação (CPF/RG).
          </li>
          <li>
            <strong>Dados de Navegação e Segurança:</strong> Endereço IP
            (Internet Protocol), data e hora de acesso, visando o cumprimento de
            obrigações legais de registro.
          </li>
        </ul>

        <h5>3. Finalidade e Uso dos Dados (Integração WhatsApp)</h5>
        <p>
          Os dados coletados são tratados de forma restrita às necessidades da
          plataforma. O uso do número de telefone associado à API do WhatsApp
          possui finalidades estritamente operacionais, compreendendo:
        </p>
        <ul>
          <li>
            <strong>Notificações Transacionais:</strong> Envio de confirmações
            de compra, atualizações de status de pagamento, links para acesso
            aos ingressos digitais e comunicados urgentes sobre alterações nos
            eventos (ex: mudança de horário ou local).
          </li>
          <li>
            <strong>Atendimento ao Cliente:</strong> Prestação de suporte
            técnico, esclarecimento de dúvidas e resolução de problemas
            relacionados à experiência de compra.
          </li>
          <li>
            Nenhum dado trafegado pelo WhatsApp será utilizado para envio de
            spam ou campanhas de marketing não autorizadas.
          </li>
        </ul>

        <h5>4. Compartilhamento e Tratamento de Dados</h5>
        <p>
          A privacidade do usuário é prioritária. Todo o tratamento de dados é
          realizado em infraestrutura nacional (Brasil).
        </p>
        <ul>
          <li>
            Não comercializamos, alugamos ou cedemos seus dados pessoais a
            terceiros, anunciantes ou parceiros comerciais.
          </li>
          <li>
            O único compartilhamento estritamente técnico ocorre com a Meta
            Platforms, Inc. (proprietária do WhatsApp), exclusivamente para
            viabilizar a infraestrutura de envio e recebimento das mensagens via
            API.
          </li>
          <li>
            Dados poderão ser fornecidos a autoridades públicas ou
            governamentais apenas mediante ordem judicial ou obrigação legal.
          </li>
        </ul>

        <h5>5. Segurança da Informação</h5>
        <p>
          Adotamos medidas técnicas e administrativas de segurança para proteger
          os dados pessoais contra acessos não autorizados, perdas, alterações
          ou vazamentos. O tráfego das informações e os pagamentos são
          protegidos por criptografia de ponta a ponta.
        </p>

        <h5>6. Retenção e Armazenamento</h5>
        <p>
          Os dados pessoais serão mantidos de forma segura em nossos servidores
          pelo período mínimo de 5 (cinco) anos. Esta retenção atende
          exclusivamente ao cumprimento de obrigações legais, regulatórias,
          fiscais e ao exercício regular de direitos em processos judiciais ou
          administrativos, conforme resguardado pela LGPD.
        </p>

        <h5>7. Direitos do Titular dos Dados (Opt-out e Exclusão)</h5>
        <p>
          Em conformidade com a LGPD e as políticas da Meta, o usuário possui
          total controle sobre seus dados, podendo exercer os seguintes
          direitos:
        </p>
        <ul>
          <li>
            <strong>Revogação de Consentimento (Opt-out):</strong> O usuário
            pode solicitar a qualquer momento a interrupção do envio de
            mensagens pelo WhatsApp. O bloqueio das mensagens será processado
            imediatamente.
          </li>
          <li>
            <strong>Solicitação de Exclusão:</strong> O usuário pode requerer a
            exclusão de sua conta. A exclusão definitiva das informações nos
            bancos de dados ocorrerá após o término do prazo legal obrigatório
            de retenção (5 anos).
          </li>
          <li>
            <strong>Acesso e Correção:</strong> Direito de solicitar a exibição
            e a correção de dados incompletos ou desatualizados.
          </li>
        </ul>
        <p>
          Para exercer quaisquer destes direitos, tirar dúvidas ou acionar nosso
          Encarregado de Proteção de Dados (DPO), o usuário deve enviar uma
          solicitação formal para o canal de atendimento oficial:
          <a href="mailto:contato@tiq.one">contato@tiq.one</a>.
        </p>

        <div class="d-flex justify-start">
          <router-link to="/terms/contract">
            <span>Veja também os termos e condições de uso.</span>
          </router-link>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { legalInfo } from "@/themeConfig.js";

export default {
  data: () => ({
    legalInfo,
  }),
};
</script>

<style>
li {
  margin-bottom: 1rem;
  text-align: justify;
}

p {
  text-align: justify;
}

h5 {
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
}
</style>
